import { httpRequest } from '../../../../app/common/util/api-common.util';

class PcrAPI {
  static cancelamentoPcr(laudo, justificativa) {
    return httpRequest(`laudos/${laudo}/etapas/pcr/cancelamento`, 'PATCH', {
      justificativa: justificativa,
    }).then((json) => json.data);
  }
}

export default PcrAPI;



// WEBPACK FOOTER //
// ./src/pages/laudo/etapas/pcr/pcr.api.js